import { useState } from "react";
import {
    Dialog,
    DialogContent,
    DialogTrigger,
} from "@/components/ui/dialoglogin";
import { Button } from "@nextui-org/react";
import { useGetAllRequests, useRejectRequest } from "@/services/request.service";
import { toast } from "react-toastify";

interface RequestRejectDialogProps {
    trigger: React.ReactNode
    requestId: string;
    onReject: () => void
}

const RequestRejectDialog = ({ trigger, requestId, onReject }: RequestRejectDialogProps) => {
    const [isOpen, setIsOpen] = useState(false); // State to control open/close of modal
    const closeDialog = () => {
        setIsOpen(false);
    };

    const { refetch } = useGetAllRequests({ page: 1, pageSize: 10 });

    const { mutate: rejectRequest } = useRejectRequest();

    function handleSubmit() {
        rejectRequest({requestId: requestId}, {
            onSuccess: () => {
                console.log('Request rejected')
                refetch()
                toast.success('Request rejected');
                closeDialog(); // Close the loginDialog on success
                onReject();
            },
            onError: (error) => {
                console.error(error);
                toast.error('Error when rejecting request');
            }
        });
    }

    return (
        <Dialog open={isOpen} onOpenChange={setIsOpen}>
            <DialogTrigger asChild>
                {trigger}
            </DialogTrigger>
            <DialogContent
                onClose={closeDialog}
                className="w-[80%] sm:w-80 h-[40%] sm:h-80 p-0"
            >
                <div className="bg-[#14142A] sm:rounded-t-lg sm:rounded-b-lg">
                    <div className="flex items-center justify-center text-center p-3 mt-4">
                        <span className="text-white text-2xl font-semibold font-montserrat">Are You Sure You Want to Reject This Request?</span>
                    </div>
                    <div className="flex items-center justify-center text-center p-3">
                        <span className="text-white text-sm font-normal font-montserrat">Rejecting this request will remove it permanently from your site. This action cannot be undone, and we will not be able to answer any questions or assist you with this request. Please confirm if you wish to proceed.</span>
                    </div>
                    <div className={`flex items-center justify-center p-3`}>
                        <Button onClick={handleSubmit} className="bg-[#FF5E5E] font-ubuntu w-[96%] rounded-md text-base text-white font-bold">
                            Confirm
                        </Button>
                    </div>
                </div>

            </DialogContent>
        </Dialog>
    )
}

export default RequestRejectDialog;